/**
 * Footer Mailchimp subscribe via JSONP (no redirect / CORS).
 */
document.addEventListener('DOMContentLoaded', function () {
  initNewsletterForm();
});

function getNewsletterJsonpUrl(form) {
  var action = form.getAttribute('action') || '';
  return action.replace('/post?', '/post-json?').replace(/\/post$/, '/post-json');
}

function setNewsletterStatus(form, statusEl, type, message) {
  if (!statusEl) return;

  var emailInput = form.querySelector('#mce-EMAIL, input[name="EMAIL"]');
  var submitBtn = form.querySelector('#mc-embedded-subscribe, button[type="submit"]');
  var isSuccess = type === 'success';

  statusEl.hidden = !message;
  statusEl.textContent = message || '';
  statusEl.classList.toggle('is-success', isSuccess);
  statusEl.classList.toggle('is-error', type === 'error');
  form.classList.toggle('is-success', isSuccess);

  if (emailInput) {
    emailInput.hidden = isSuccess;
    emailInput.disabled = isSuccess;
  }

  if (submitBtn) {
    submitBtn.hidden = isSuccess;
    submitBtn.disabled = isSuccess;
  }
}

function stripNewsletterHtml(value) {
  var el = document.createElement('div');
  el.innerHTML = value || '';
  return (el.textContent || el.innerText || '').replace(/\s+/g, ' ').trim();
}

function submitNewsletterJsonp(form, statusEl, submitBtn) {
  var emailInput = form.querySelector('#mce-EMAIL, input[name="EMAIL"]');
  var email = emailInput ? emailInput.value.trim() : '';

  if (!email || (emailInput && typeof emailInput.checkValidity === 'function' && !emailInput.checkValidity())) {
    setNewsletterStatus(form, statusEl, 'error', 'Please enter a valid email address.');
    if (emailInput && typeof emailInput.reportValidity === 'function') emailInput.reportValidity();
    return;
  }

  var params = new URLSearchParams();
  var formData = new FormData(form);
  formData.forEach(function (value, key) {
    params.append(key, value);
  });

  var callbackName = 'mcJsonpCallback_' + String(Date.now());
  var baseUrl = getNewsletterJsonpUrl(form);
  var separator = baseUrl.indexOf('?') === -1 ? '?' : '&';
  var script = document.createElement('script');

  if (submitBtn) submitBtn.disabled = true;
  setNewsletterStatus(form, statusEl, '', '');

  window[callbackName] = function (data) {
    delete window[callbackName];
    if (script.parentNode) script.parentNode.removeChild(script);

    if (data && data.result === 'success') {
      setNewsletterStatus(form, statusEl, 'success', 'Thanks for subscribing');
      return;
    }

    if (submitBtn) submitBtn.disabled = false;
    var errorMessage = stripNewsletterHtml(data && data.msg);
    if (!errorMessage) errorMessage = 'Something went wrong. Please try again.';
    setNewsletterStatus(form, statusEl, 'error', errorMessage);
  };

  script.src = baseUrl + separator + params.toString() + '&c=' + encodeURIComponent(callbackName);
  script.onerror = function () {
    delete window[callbackName];
    if (script.parentNode) script.parentNode.removeChild(script);
    if (submitBtn) submitBtn.disabled = false;
    setNewsletterStatus(form, statusEl, 'error', 'Something went wrong. Please try again.');
  };

  document.body.appendChild(script);
}

function initNewsletterForm() {
  var form = document.getElementById('mc-embedded-subscribe-form');
  if (!form) return;

  var statusEl = form.querySelector('[data-mc-status]');
  var submitBtn = form.querySelector('#mc-embedded-subscribe, button[type="submit"]');

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    submitNewsletterJsonp(form, statusEl, submitBtn);
  });
}
